import { format } from "date-fns";

import { resolveMinCapacity } from "./_context.js";

// ACC Whistler party-size ceiling: the Step-1 guests dropdown maxes at 6.
const PROVIDER_MAX_GUESTS = 6;

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate } = ctx;
    // Verified deep link (live QA 2026-08-07): the hash-bang route
    // rehydrates the Step-2 availability grid starting at date_from on a
    // fresh navigation. type:public is the safe default — members can
    // step back to Step 1 to toggle early-booking eligibility.
    const guests = Math.min(PROVIDER_MAX_GUESTS, resolveMinCapacity(ctx));
    const dateFrom = format(arrivalDate, "yyyy-MM-dd");
    return `${site.reserveUrl}#!/Huts/date_from:${dateFrom}/guests:${guests}/type:public`;
  },

  buildPreviewUrl(site) {
    return site.reserveUrl;
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as #!/Huts/date_from:YYYY-MM-DD.",
        },
        departureDate: {
          status: "ignored",
          notes:
            "The user selects nights on the Step-2 grid; the deep link has no checkout parameter.",
        },
        ref: {
          status: "ignored",
          notes:
            "Single-hut deployment; the grid always shows Wendy Thompson Hut.",
        },
        partySize: {
          status: "optional",
          defaultValue: 1,
          notes: "Encoded as guests:N, clamped to the provider max of 6.",
        },
      },
    };
  },
};
